import React, { useEffect, useState } from 'react';
// import { Button } from '../../components/Form';
// import { BiPlus } from 'react-icons/bi';
import { FiEye } from 'react-icons/fi';
import { GrNotes } from "react-icons/gr";
// import { toast } from 'react-hot-toast';
// import { RiDeleteBin6Line } from 'react-icons/ri';
// import { medicalRecodData } from '../../components/Datas';
// import MedicalRecodModal from '../../components/Modals/MedicalRecodModal';
import { 
  // useNavigate, 
  useParams,
  // Link,
  // useNavigate
} from 'react-router-dom';
import Modal from '../../components/Modals/Modal';
import NewMedicalRecode from './NewMedicalRecode';
import { useDispatch, useSelector } from 'react-redux';
import { getAllVisitas, getVisitas, resetVisita } from '../../redux/features/visitasSlice';
import { 
  getAllCitas,
  getCitas, 
  // getCitasByPatientId 
  updateCita
} from '../../redux/features/citasSlice';
import { BiCalendarPlus } from 'react-icons/bi';
import AddAppointmentModal_re from '../../components/Modals/AddApointmentModal_re';
import { getAllPatients } from '../../redux/features/patientSlice';
import CommentsModal from '../../components/Modals/CommentsModal';
import toast from 'react-hot-toast';
import { useForm } from 'react-hook-form';
import { getEstudiosByPatientId } from '../../redux/features/estudiosSlice';

function MedicalRecord() {
  const [isOpen, setIsOpen] = useState(false);
  const [datas, setDatas] = useState({});
  // const navigate = useNavigate();

  const {id} = useParams();
  const dispatch = useDispatch();
  const visitasData = useSelector(getAllVisitas);
  const [visitas, setVisitas] = useState(visitasData);
  const citas = useSelector(getAllCitas);

  //var de modal visita
  const patients = useSelector(getAllPatients);
  const [open, setOpen] = useState(false);
  const [dataCita, setDataCita] = useState({});
  const [isOpenComments, setIsOpenComments] = useState(false);

  useEffect(() => {
    dispatch(getVisitas(id));
    dispatch(getCitas());
  }, [visitas?.length, dataCita]);

  // useEffect(() => {
    //obtenmos el paciente
    // setPatient(visitas.find((visita) => visita.patient !== undefined || visita.patient !== null).patient);
  // });

  // handle modal close
  const handleClose = () => {
    setOpen(!open);
    setDataCita(dataCita);
  };

  // const handleLength = () => {
  //   let i = 0;
  //   visitasData.forEach(element => {
  //     if (element.cita.tipo_evento.toLowerCase() !== "re consulta") {
  //       i += 1;
  //     }
  //   });
  //   return i;
  // }

  return (
    <>
      {
        // Modal
        isOpen && (
          <Modal
            closeModal={() => {
              setIsOpen(false);
              setDatas({});
              dispatch(getEstudiosByPatientId( id ));
            }}
            isOpen={isOpen}
            title="Historia de Atenciones"
          >
            <NewMedicalRecode cita={{patient: citas?.find(cita => cita.id === datas?.cita_id)?.patient, ...datas?.cita}}/>
          </Modal>
        )
      }
      {open && (
        <AddAppointmentModal_re
          datas={dataCita}
          setDatas={setVisitas}
          patients={patients}
          isOpen={open}
          operation={{update: visitasData}}
          closeModal={() => {
            handleClose();
          }}
        />
      )}
      {
        // Modal
        isOpenComments && (
          <CommentsModal
            closeModal={() => {
              setIsOpenComments(false);
            }}
            dataCita={dataCita}
            isOpen={isOpenComments}
            title="Notas de la re consulta"
          />
        )
      }
      <div className="flex flex-col gap-6">
        <div className="flex-btn gap-4">
          <h1 className="text-sm font-medium sm:block hidden">
            Historial Medico - Registros({visitasData?.length ?? 0})
          </h1>
          <div className="sm:w-1/4 w-full">
          </div>
        </div> 
        {visitasData?.map((data, index) => (
          data.cita.tipo_evento !== "Analisis o Laboratorio"  &&
          data.cita.estado.toLowerCase() === "cerrada"
          &&
          <div
            key={data.id}
            className="bg-dry items-start grid grid-cols-12 gap-4 rounded-xl border-[1px] border-border p-6"
          >
            <div className="col-span-12 md:col-span-2">
              <p className="text-xs text-textGray font-medium">{new Date(data.cita.fecha).toLocaleDateString("es-ES")}</p>
            </div>
            <div className="col-span-12 md:col-span-6 flex flex-col gap-2">
              
                <p className="text-xs text-main font-light">
                  <span className="font-medium">Motivo:</span>{' '}
                  {
                    data.motivo?.length > 40
                      ? `${data.motivo.slice(0, 40)}...`
                      : data.motivo
                  }
                </p>
                <p className="text-xs text-main font-light">
                  <span className="font-medium">Notas:</span>{' '}
                  {
                    data?.cita.tipo_evento.toLowerCase() === "re consulta" ? data?.cita.comentarios : data?.comentarios
                  }
                </p>
                {/* <p className="text-xs text-main font-light">
                  <span className="font-medium">Diagnostico:</span>{' '}
                  {
                    data.diagnostico?.length > 40
                      ? `${data.diagnostico?.replace('|', ', ').slice(0, 40)}...`
                      : data.diagnostico?.replace('|', ', ')
                  }
                </p>
                <p className="text-xs text-main font-light">
                  <span className="font-medium">Comentarios:</span>{' '}
                  {
                    data.comentarios?.length > 40
                      ? `${data.comentarios?.slice(0, 40)}...`
                      : data.comentarios
                  }
                </p>
                <p className="text-xs text-main font-light">
                  <span className="font-medium">Conducta:</span>{' '}
                  {
                    data.conducta?.length > 40
                      ? `${data.conducta?.slice(0, 40)}...`
                      : data.conducta
                  }
                </p>
                <p className="text-xs text-main font-light">
                  <span className="font-medium">Asitencia:</span>{' '}
                  {
                    data?.cita?.estado === "cerrada"
                      ? "Asistio" : "No Asistio"
                  }
                </p> */}
            </div>
            {/* price */}
            <div className="col-span-12 md:col-span-2">
              <p className="text-xs text-subMain font-semibold">
                <span className="font-light text-main">{data?.cita?.tipo_evento}</span>{' '}
              </p>
            </div>
            {/* actions */}
            <div className="col-span-12 md:col-span-2 flex-rows gap-2">
              {data?.cita?.tipo_evento !== "Re Consulta" ? (
                  <>
                    <button
                      title='Ver Historial'
                      onClick={() => {
                        setIsOpen(true);
                        setDatas(data);
                        dispatch(resetVisita());
                      }}
                      className="text-sm flex-colo bg-white text-subMain border border-border rounded-md w-2/4 md:w-10 h-10"
                    >
                      <FiEye />
                    </button>
                    <button
                      title='Agendar Re Consulta'
                      // onClick={handleClose}
                      onClick={() => {
                        setOpen(true);
                        setDataCita(citas.find(cita => cita.id === data.cita_id));

                      }}
                      className="text-sm flex-colo bg-white text-subMain border border-border rounded-md w-2/4 md:w-10 h-10"
                    >
                      <BiCalendarPlus />
                    </button>
                  </>
                ):(
                  <button
                      title='Ver Re Consulta'
                      onClick={() => {
                        setIsOpen(true);
                        setDatas(data);
                        dispatch(resetVisita());
                      }}
                      className="text-sm flex-colo bg-white text-subMain border border-border rounded-md w-2/4 md:w-10 h-10"
                    >
                      <FiEye />
                    </button>
                )
                }
              {/* <button
                onClick={() => {
                  toast.error('No disponible');
                }}
                className="text-sm flex-colo bg-white text-red-600 border border-border rounded-md w-2/4 md:w-10 h-10"
              >
                <RiDeleteBin6Line />
              </button> */}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default MedicalRecord;
